import { useQuery } from "react-query";

import { fetchFeatureModules } from "modules/user/api/features";

export const FEATURE_MODULES_QUERY_KEY = "/feature_modules";

export const useFeatureModulesQuery = () => {
  const queryResults = useQuery({
    queryFn: fetchFeatureModules,
    queryKey: [FEATURE_MODULES_QUERY_KEY],
    cacheTime: Infinity,
    staleTime: Infinity
  });

  return queryResults;
};
